import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addItemToBasketApi,
  getItemInBasketApi,
  removeItemFromBasketApi,
  updateItemToBasketApi,
} from "../../services/products";
import { parseApiError } from "../../utils/api_error";

// Add to cart
export const addToCartAPI = createAsyncThunk(
  "itemCart/addToCartAPI",
  async (item, { rejectWithValue }) => {
    try {
      const res = await addItemToBasketApi(item);
      return res; // updated cart from backend
    } catch (err) {
      const message = parseApiError(err);
      return rejectWithValue(message);
    }
  },
);

export const updateToCartAPI = createAsyncThunk(
  "itemCart/updateToCartAPI",
  async (item, { dispatch, rejectWithValue }) => {
    try {
      const res = await updateItemToBasketApi(item);
      await dispatch(fetchCartAPI());
      return res; // updated cart from backend
    } catch (err) {
      const message = parseApiError(err);
      return rejectWithValue(message);
    }
  },
);

export const fetchCartAPI = createAsyncThunk(
  "itemCart/fetchCartAPI",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getItemInBasketApi();
      return res;
    } catch (err) {
      const message = parseApiError(err);
      return rejectWithValue(message);
    }
  },
);

export const updateQtyAPI = createAsyncThunk(
  "itemCart/updateQtyAPI",
  async (item, { rejectWithValue }) => {
    try {
      const res = await removeItemFromBasketApi(item);
      return res;
    } catch (err) {
      const message = parseApiError(err);
      return rejectWithValue(message);
    }
  },
);

export const removeFromCartAPI = createAsyncThunk(
  "itemCart/removeFromCartAPI",
  async (id, { dispatch, rejectWithValue }) => {
    try {
      const res = await removeItemFromBasketApi(id);
      await dispatch(fetchCartAPI());
      return res;
    } catch (err) {
      const message = parseApiError(err);
      return rejectWithValue(message);
    }
  },
);
